import type { ReactNode } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import s from "../RollingSubmissionDetail.module.css";
import { formatDateTimeShort } from "@/utils/dateFormatter";

export function ChevronSvg() {
  return (
    <svg
      className={s.chevron}
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <path d="M4 2l4 4-4 4" />
    </svg>
  );
}

export function GripIcon() {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor">
      <circle cx="2" cy="2" r="1.5" />
      <circle cx="8" cy="2" r="1.5" />
      <circle cx="2" cy="8" r="1.5" />
      <circle cx="8" cy="8" r="1.5" />
      <circle cx="2" cy="14" r="1.5" />
      <circle cx="8" cy="14" r="1.5" />
    </svg>
  );
}

export function SortableAccordionItem({
  id,
  children,
}: {
  id: string;
  children: (dragHandleProps: {
    listeners: ReturnType<typeof useSortable>["listeners"];
    attributes: ReturnType<typeof useSortable>["attributes"];
  }) => ReactNode;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });
  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };
  return (
    <div ref={setNodeRef} style={style}>
      {children({ listeners, attributes })}
    </div>
  );
}

export function AuditBlock({
  created,
  modified,
  modifiedBy,
}: {
  created: string | null;
  modified: string | null;
  modifiedBy: string | null;
}) {
  return (
    <div className={s.auditInfo}>
      <span>
        Created <span className={s.auditValue}>{created ? formatDateTimeShort(created) : "—"}</span>
      </span>
      <span>
        {modified ? (
          <>
            Modified <span className={s.auditValue}>{formatDateTimeShort(modified)}</span>
            {modifiedBy ? (
              <>
                {" "}
                by <span className={s.auditValue}>{modifiedBy}</span>
              </>
            ) : null}
          </>
        ) : (
          "Not modified since submission"
        )}
      </span>
    </div>
  );
}
